import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateAccountSettingsBadges = createMutationHook(
  MembershipsCreatorApiClient.updateAccountSettingsBadges,
  {
    mutationKey: ['updateAccountSettingsBadges'],
  },
)
